var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticClass: "add-member",
      attrs: { title: "Add Club Admin" },
      on: { cancel: _vm.close },
      model: {
        value: _vm.isVisible,
        callback: function ($$v) {
          _vm.isVisible = $$v
        },
        expression: "isVisible",
      },
    },
    [
      _c(
        "a-row",
        [
          _c(
            "a-col",
            { attrs: { lg: 24, md: 24, sm: 24, xs: 24 } },
            [
              _c(
                "a-form",
                { attrs: { form: _vm.form }, on: { submit: _vm.addMember } },
                [
                  _c(
                    "a-form-item",
                    [
                      _c(
                        "a-row",
                        {
                          staticStyle: { "margin-left": "5px" },
                          attrs: { type: "flex", align: "middle", gutter: 1 },
                        },
                        [
                          _c(
                            "a-col",
                            { attrs: { xs: 2 } },
                            [_c("a-icon", { attrs: { type: "team" } })],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { xs: 22 } },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "club_name",
                                      {
                                        rules: [
                                          {
                                            required: true,
                                            message: "Club name is required.",
                                          },
                                        ],
                                      },
                                    ],
                                    expression:
                                      "[\n                  'club_name',\n                  {\n                    rules: [\n                      { required: true, message: 'Club name is required.' },\n                    ],\n                  },\n                ]",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                  placeholder: "Enter club name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    [
                      _c(
                        "a-row",
                        {
                          staticStyle: { "margin-left": "5px" },
                          attrs: { type: "flex", align: "middle", gutter: 1 },
                        },
                        [
                          _c(
                            "a-col",
                            { attrs: { xs: 2 } },
                            [_c("a-icon", { attrs: { type: "mail" } })],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { xs: 22 } },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "work_email",
                                      {
                                        rules: [
                                          {
                                            required: true,
                                            message: "Email is required.",
                                          },
                                          {
                                            type: "email",
                                            message: "Email is invalid.",
                                          },
                                        ],
                                      },
                                    ],
                                    expression:
                                      "[\n                  'work_email',\n                  {\n                    rules: [\n                      { required: true, message: 'Email is required.' },\n                      { type: 'email', message: 'Email is invalid.' },\n                    ],\n                  },\n                ]",
                                  },
                                ],
                                attrs: {
                                  type: "email",
                                  placeholder: "Enter email",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    [
                      _c(
                        "a-row",
                        {
                          staticStyle: { "margin-left": "5px" },
                          attrs: { type: "flex", align: "middle", gutter: 1 },
                        },
                        [
                          _c(
                            "a-col",
                            { attrs: { xs: 2 } },
                            [_c("a-icon", { attrs: { type: "user-add" } })],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { xs: 22 } },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "first_name",
                                      {
                                        rules: [
                                          {
                                            required: true,
                                            message: "First name is required.",
                                          },
                                          {
                                            min: 3,
                                            message:
                                              "First name should contain at least 3 Characters.",
                                          },
                                          {
                                            max: 20,
                                            message:
                                              "Sorry You are Exceeding the Limit.",
                                          },
                                        ],
                                      },
                                    ],
                                    expression:
                                      "[\n                  'first_name',\n                  {\n                    rules: [\n                      { required: true, message: 'First name is required.' },\n                      {\n                        min: 3,\n                        message:\n                          'First name should contain at least 3 Characters.',\n                      },\n                      {\n                        max: 20,\n                        message: 'Sorry You are Exceeding the Limit.',\n                      },\n                    ],\n                  },\n                ]",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                  placeholder: "Enter first name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    [
                      _c(
                        "a-row",
                        {
                          staticStyle: { "margin-left": "5px" },
                          attrs: { type: "flex", align: "middle", gutter: 1 },
                        },
                        [
                          _c(
                            "a-col",
                            { attrs: { xs: 2 } },
                            [_c("a-icon", { attrs: { type: "user-add" } })],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { xs: 22 } },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: [
                                      "last_name",
                                      {
                                        rules: [
                                          {
                                            required: true,
                                            message: "Last name is required.",
                                          },
                                          {
                                            min: 3,
                                            message:
                                              "Last name should contain at least 3 Characters.",
                                          },
                                          {
                                            max: 20,
                                            message:
                                              "Sorry You are Exceeding the Limit.",
                                          },
                                        ],
                                      },
                                    ],
                                    expression:
                                      "[\n                  'last_name',\n                  {\n                    rules: [\n                      { required: true, message: 'Last name is required.' },\n                      {\n                        min: 3,\n                        message:\n                          'Last name should contain at least 3 Characters.',\n                      },\n                      {\n                        max: 20,\n                        message: 'Sorry You are Exceeding the Limit.',\n                      },\n                    ],\n                  },\n                ]",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                  placeholder: "Enter last name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    [
                      _c(
                        "a-row",
                        {
                          staticClass: "gx-text-right",
                          staticStyle: { "margin-top": "0px" },
                          attrs: { type: "block", gutter: 1 },
                        },
                        [
                          _c(
                            "a-button",
                            {
                              attrs: {
                                "inline-block": "",
                                type: "primary",
                                "html-type": "submit",
                                loading: _vm.memberLoading,
                              },
                            },
                            [_vm._v("Add Club Admin")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }